import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import CartAction from "../stores/actions/CartAction";
import POProductAction from "../stores/actions/POProductAction";

const POAddToCart = ({
  productId,
  cartQty,
  rowAmount,
  rowTax,
  totalAmount,
  totalTax,
  qty,
  getPOProductList,
  id,
  hit,
  setHit,
  minSaleQty,
}: any) => {
  const dispatch = useDispatch<any>();
  const [loader, setLoader] = useState<boolean>(false);
  const [updateLoader, setUpdateLoader] = useState<boolean>(false);

  const [qtyCount, setQtyCount] = useState<any>(cartQty);

  const addCount = async () => {
    await updateQty("increase", Number(cartQty) + Number(minSaleQty));
  };
  const minusCount = async () => {
    await updateQty("decrease", Number(cartQty) - Number(minSaleQty));
  };

  const updateQty = async (action: string, qtyCount: number) => {
    if (Number(qtyCount) > Number(qty)) {
      toast.error(`The maximum quantity demanded by the buyer is ${qty}`);
      return false;
    } else if (Number(qtyCount) <= 1) {
      toast.error(`minimum ${minSaleQty} qty`);
      return false;
    }

    setQtyCount(qtyCount);

    setUpdateLoader(true);
    try {
      dispatch(
        CartAction.updatePoOrderQty({
          id: productId,
          action: action,
          supply_qty: qtyCount,
        })
      );
      setUpdateLoader(false);
      await dispatch(POProductAction.getPOOrderItems({ id: id }));
      await getPOProductList();
    } catch (error: any) {
      setUpdateLoader(false);
      toast.error(error.message);
    }
  };

  const updateQtyBulk = async () => {
    if (Number(qtyCount) <= Number(minSaleQty)) {
      toast.error(`Please enter minimum minimum ${minSaleQty} qty`);
      return false;
    }

    if (Number(qtyCount) > Number(qty)) {
      toast.error(`The maximum quantity demanded by the buyer is ${qty}`);
      return false;
    }

    setUpdateLoader(true);
    try {
      await dispatch(
        CartAction.updatePoOrderQty({
          id: productId,
          action: "input",
          supply_qty: qtyCount,
        })
      );
      setQtyCount(qtyCount);
      setUpdateLoader(false);
      setHit(hit + 1);
      await getPOProductList();
    } catch (error: any) {
      setUpdateLoader(false);
      toast.error(error.message);
    }
  };

  return (
    <div className={"d-flex justify-content-between"}>
      {updateLoader ? (
        <i className={"fa fa-spinner fa-spin"}></i>
      ) : (
        <div className="d-flex">
          <button
            type="button"
            onClick={minusCount}
            className="btn btn-primary btn-sm rounded-0"
            disabled={updateLoader}>
            -
          </button>
          <input
            className="text-center border-gray"
            type="text"
            style={{ width: 30 }}
            value={qtyCount}
            onChange={(e: any) => setQtyCount(e.target.value)}
            onBlur={updateQtyBulk}
            readOnly={updateLoader}
          />
          <button
            type="button"
            onClick={addCount}
            className="btn btn-primary btn-sm rounded-0"
            disabled={updateLoader}>
            +
          </button>
        </div>
      )}
    </div>
  );
};

export default POAddToCart;
